import React, { useState, useEffect } from "react";
import { ReactComponent as Spinner } from "../../../assets/spinner.svg";
import { toastr } from "react-redux-toastr";
import firebase from "../../../app/config/firebase";
import classes from "./UserList.module.css";

const EditDistrictForm = ({
  district = {}, 
  onSubmit,
  loading,
  error,
}) => {
  const [formValues, setFormValues] = useState({
    district: district.district || "", 
    branch: district.branch || "", 
  });

  const [branches, setBranches] = useState([]); 
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const branchSnapshot = await firebase.firestore().collection('branches').get();
       
        const branchList = branchSnapshot.docs.map(doc => doc.data().branch); 
        setBranches(branchList);
      } catch (error) {
        setErrors({ fetchBranches: "Error fetching branches. Please try again." });
      }
    };

    fetchBranches();
  }, []);  

  useEffect(() => {
    setFormValues({
      district: district.district || "",
      branch: district.branch || "",
    });
  }, [district]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (!formValues.district || !formValues.branch) {
      setErrors({ form: "Both district and branch are required." });
      return;
    }

    setErrors({});
    updateDistrictDetails(district.id, formValues);
  };

    const updateDistrictDetails = async (districtId, updatedValues) => {
    try {
      await firebase.firestore().collection('botswana_districts').doc(districtId).update({
        district: updatedValues.district,
        branch: updatedValues.branch,
      });

      toastr.success("Success", "District details updated successfully.");

      if (onSubmit) {
        onSubmit(updatedValues);
      }

    } catch (error) {
      setErrors({ update: "Error updating district details. Please try again." });
    }
  };

  return (
    <div className={"full-height sm-p-t-30"}>
      <div className={"d-flex justify-content-center flex-column full-height"}>
        <form className={"p-t-15"} onSubmit={handleFormSubmit} style={{ width: '100%' }}>
          <div className={"row"} style={{ marginBottom: '20px' }}>
            <div className={"col-md-6"}>
              <div className="form-group">
                <label style={{ display: 'block', marginBottom: '5px' }}>District</label>
                <input
                  type="text"
                  name="district"
                  value={formValues.district}
                  onChange={handleChange}
                  placeholder="District"
                  className={"form-control"}
                  disabled
                  style={{ width: '100%', padding: '8px' }}
                />
                {errors.district && <small className="text-danger">{errors.district}</small>}
              </div>
            </div>

            <div className={"col-md-6"}>
              <div className="form-group">
                <label style={{ display: 'block', marginBottom: '5px' }}>Branch</label>
                <select
                  name="branch"
                  value={formValues.branch}
                  onChange={handleChange}
                  className={"form-control"}
                  required
                  style={{ width: '100%', padding: '8px' }}
                >
                  <option value="">Select Branch...</option>
                  {branches.map((branch, index) => (
                    <option key={index} value={branch}>
                      {branch}
                    </option>
                  ))}
                </select>
                {errors.branch && <small className="text-danger">{errors.branch}</small>}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              {error && <label className={"error semi-bold"}>{error}</label>}
              {errors.form && <label className={"error semi-bold"}>{errors.form}</label>}
              <button 
                className={classes.EditUserBtn} 
                type="submit" 
                disabled={loading}
                style={{ width: '100%', marginTop: '10px' }}
              >
                {loading ? (
                  <Spinner style={{ width: "20px", height: "20px", verticalAlign: "middle" }} />
                ) : (
                  <span>Update District</span>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDistrictForm;
